export const numberFormatToPtBr = (number) => {
  if (typeof number !== 'number') throw new Error('only numbers accepted');

  let intlOptions = {
    style: 'decimal',
    maximumFractionDigits: 2,
  };

  if (!Number.isInteger(number)) {
    intlOptions = { ...intlOptions, minimumFractionDigits: 2 };
  }

  return new Intl.NumberFormat('pt-BR', intlOptions).format(number);
};
